/* eslint-disable */
import React from "react";
import { getPropertyCalendar } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const CalendarEventsProperties = ({ getPropertyCalendar, propertyCalendar, period }) => (
  <DataTable
    {...tablePresets.calendarEventsProperties}
    data={propertyCalendar}
    fetchData={getPropertyCalendar}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyCalendar: state.appProperties.propertyCalendar,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyCalendar: (payload) => dispatch(getPropertyCalendar(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarEventsProperties);
